import classNames from 'classnames'
import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import { ReactComponent as DealsIcon } from './icon-deals.svg'
import { ReactComponent as SystemIcon } from './icon-system.svg'
import { ReactComponent as TimeIcon } from './icon-time.svg'
import { ReactComponent as UnsureIcon } from './icon-unsure.svg'
import { ReactComponent as BulletIcon } from '../bullet.svg'


export default function HurdleStep({ onSubmit, options: optionsOverride }) {
  let [option, setOption] = useState()
  let defaultOptions = [
    { icon: DealsIcon, value: 'deals', label: 'Ich finde zu wenig Deals' },
    { icon: SystemIcon, value: 'system', label: 'Mir fehlt ein klares System' },
    { icon: TimeIcon, value: 'time', label: 'Ich habe zu wenig Zeit' },
    { icon: UnsureIcon, value: 'unsure', label: 'Ich bin unsicher bei Deals' },
  ]
  let options = optionsOverride ?? defaultOptions

  let disabled = !option

  return (
    <div className='flex flex-col w-full h-full items-center justify-center'>
      <Card withGradient>

        <div className='px-24 py-12 flex text-white gap-36 items-center'>
          <div className='flex flex-col gap-4 w-72 items-start'>
            <div className='text-2xl font-bold'>
            Was sind deine größten Hürden aktuell?
            </div>
            <div className='text-neutral-500 text-lg'>
              Welche Themen halten dich aktuell vom skalieren ab? Liegt es an einem fehlenden System, zu wenig Erfahrung oder Zeit?
            </div>
            <Button
                variant='secondary'
                className='text-primary'
                disabled={disabled}
                onClick={() => !disabled && onSubmit({ hurdle: option })}
            >
              <strong className={classNames('px-12 font-bold', !disabled && 'text-primary')}>Weiter</strong>
            </Button>
          </div>

          <div className='flex flex-col gap-4'>
            {options.map((opt) => (
              <div
                key={opt.value}
                className={classNames(
                  'cursor-pointer p-3 rounded-2xl flex gap-2 items-center border-2 min-w-72',
                  option === opt.value ? 'border-primary text-primary bg-secondary' : ' border-neutral-800 text-neutral-300'
                )}
                onClick={() => setOption(opt.value)}
              >
                <opt.icon style={{ width: '28px', height: '28px' }} className={classNames(option !== opt.value && 'text-neutral-600')} />
                <span className='flex-1'>{opt.label}</span>
                <BulletIcon
                  className={classNames('ml-8 mr-2', option === opt.value ? 'text-primary' : 'text-neutral-800')}
                />
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  )
}
